<template>
  <a-config-provider :locale="state.locale">
    <RouterView></RouterView>
  </a-config-provider>
</template>

<script lang="ts" setup>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn';
  import { reactive, onMounted } from 'vue';
  import Router from './Router';
  import { AccountService } from './Services/AccountService';

  dayjs.locale('zh-cn');
  const state = reactive({
    locale: zhCN
  });

  onMounted(async () => {
    // 从 localStorage 中读取 'user-token'
    const token = localStorage.getItem('OnlineBusinessHall.Token');
    if (token) {
      // 更新令牌，延续令牌可用性
      await AccountService.heartbeatKeep().then((is_success:boolean) => {
        if (!is_success) {
          // 跳转到登录页
          Router.push({ path: '/login' });
        } else {
          Router.push({ path: '/backend' });
        }
      }).catch(() => {
        // 令牌已过期，跳转到登录页
        Router.push({ path: '/login' });
      });
    } else {
      // 跳转到登录页
      Router.push({ path: '/login' });
    }
  })
</script>